import React from 'react';
import PropTypes from 'prop-types';
import '../../../styles/WhyMMTRail.css';
import { productFeaturesCardData } from '../constants/PnrSeoConstants';

const WhyMMTRail = ({ customClass = '' }) => {
  const { label, listItems } = productFeaturesCardData;

  return (
    <div className={`whyMMTRail ${customClass} appendTop30`}>
      <h2>{label}</h2>
      <ul>
        {listItems.map((item) => (
          <li key={item.label}>
            <span className={`${item.iconName} appendRight16`}></span>
            <div>
              <p className="listLabel">{item.label}</p>
              <p className="listSubLabel">{item.subLabel}</p>
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
};

WhyMMTRail.propTypes = {
  customClass: PropTypes.string
};

export default WhyMMTRail;
